import { Accordion, AccordionSummary, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
const PastSeasonColumnContainer = ({
  heading,
  data,
  handleClick,
  active,
  fieldToShow,
  isObject,
  isPracticeList,
}) => {
  return (
    <>
      <Paper className="min-width-300">
        <h1 className="storage-title bold">{heading}</h1>
        <div className="current-video">
          {!isObject
            ? data?.map((el, index) => (
                <div
                  key={index}
                  className="crnt-btn cp"
                  id="event-btn"
                  onClick={() => handleClick(el)}
                >
                  <Accordion
                    disableGutters
                    className={`event-box w-100 cp ${
                      active?.[fieldToShow] === el[fieldToShow] && "active-btn"
                    }`}
                  >
                    <AccordionSummary
                      aria-controls="panel2bh-content"
                      id="panel2bh-header"
                      className="d-flex cp"
                    >
                      <Typography
                        sx={{
                          width: "100% !important",
                          flexShrink: 0,
                          cursor: "pointer",
                        }}
                      >
                        {el[fieldToShow].replaceAll("-", " - ")}
                      </Typography>
                    </AccordionSummary>
                  </Accordion>
                </div>
              ))
            : Object.keys(!isPracticeList ? data : data?.arr).map(
                (el, index) => (
                  <div
                    key={index}
                    className="crnt-btn cp"
                    id="event-btn"
                    onClick={() => {
                      handleClick(!isPracticeList ? data?.[el] : data?.arr[el]);
                    }}
                  >
                    <Accordion
                      disableGutters
                      className={`event-box w-100 ${
                        (!isPracticeList
                          ? active?.[fieldToShow] === data?.[el][fieldToShow]
                          : active?.[fieldToShow] ===
                            data?.arr[el]?.[fieldToShow]) &&
                        Object.keys(data).length &&
                        "active-btn"
                      }`}
                    >
                      <AccordionSummary
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                        className="d-flex"
                      >
                        <Typography
                          sx={{
                            width: "100% !important",
                            flexShrink: 0,
                            cursor: "pointer",
                          }}
                        >
                          {!isPracticeList
                            ? data?.[el][fieldToShow]
                            : data?.arr[el]?.practiceName}
                        </Typography>
                      </AccordionSummary>
                    </Accordion>
                  </div>
                )
              )}
        </div>
      </Paper>
    </>
  );
};

export default PastSeasonColumnContainer;
